/* sync.svelte.ts generated by Svelte v5.55.3 */
import * as $ from 'svelte/internal/client';

let syncStatus = $.state($.proxy({
	connected: false,
	syncing: false,
	lastSyncAt: null,
	error: null,
	userId: null,
	syncGroupId: null
}));

export function getSyncStatus() {
	return $.get(syncStatus);
}

export function setSyncStatus(updates) {
	$.set(syncStatus, { ...$.get(syncStatus), ...updates }, true);
}